module.exports = __webpack_public_path__ + "static/media/project8.80f57873.jpg";